

























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'PaymentCardSummary',
  components: {
    SvgImage,
  },
  props: {
    selectedCard: {
      type: Object,
      required: true,
    },
    selectedInstallment: {
      type: Object,
      required: true,
    },
    decrypt: {
      type: Function as PropType<(value: string, cvi: string) => string>,
      required: true,
    },
  },
  setup() {
    const formatCurrency = (value: number, currency: string = 'BRL', locale: string = 'pt-BR') => new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(value);
    function censoredText(text: string) {
      return text.replace(/\S/g, (char, index) => (index < 14 ? '\u25CF' : char));
    }
    return {
      censoredText,
      formatCurrency,
    };
  },
});
